// Four stops rather than two: a plain gradient meets the content as a line.
export const SCROLL_FADE_HEIGHT = "2.5rem";

export const SCROLL_FADE_BOTTOM =
  "linear-gradient(to bottom, transparent, color-mix(in oklab, var(--foreground) 3%, transparent) 45%, color-mix(in oklab, var(--foreground) 8%, transparent) 75%, color-mix(in oklab, var(--foreground) 14%, transparent))";

export const SCROLL_FADE_TOP =
  "linear-gradient(to top, transparent, color-mix(in oklab, var(--background) 45%, transparent) 45%, color-mix(in oklab, var(--background) 80%, transparent) 75%, var(--background))";
